import React from "react";
import { View, StyleSheet, Text, Platform } from "react-native";

import AppTheme from "../../AppTheme";
import Dialog from "../../common/dialog";
import ManaButton from "../../common/ManaButton";
import IntegrationIcons from "../../common/icons/integrations";
import IntegrationWrapper from "../details/IntegrationWrapper";

export default function DeleteIgnoreRuleDialog({
  controller,
  integration = {},
  confirm = () => {},
  cancel = () => {},
  associate = () => {},
}) {
  return (
    <Dialog.Container
      onClose={cancel}
      showCloseButton
      style={styles.container}
      headerStyle={{ margin: 0 }}
      contentStyle={{
        marginTop: 0,
        paddingTop: 8,
        paddingBottom: 12,
        minHeight: 360,
      }}
    >
      <View style={styles.header}>
        <Text style={styles.title}>Are you sure?</Text>
        <IntegrationWrapper
          controller={controller}
          data={integration}
          style={{ marginBottom: 0, paddingVertical: 4, width: "100%" }}
        />

        <Text style={styles.description}>
          We’ll use this data to make predictions about your activity now.
        </Text>
      </View>

      <View
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <IntegrationIcons.ResumeTrackingIcon style={styles.imageBg} />
      </View>

      <View style={[styles.buttons, { marginTop: 16 }]}>
        <ManaButton
          style={[styles.button, { marginRight: 6 }]}
          styleText={styles.buttonText}
          text="Cancel"
          onPress={cancel}
        />

        <ManaButton
          isMainButton
          style={[styles.button]}
          styleText={styles.buttonText}
          text="Confirm"
          onPress={confirm}
        />
      </View>

      <Text
        style={styles.associatedText}
        onPress={() => associate(integration)}
      >
        or associate data with Element
      </Text>
    </Dialog.Container>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
  },
  close: {
    position: "absolute",
    top: 5,
    right: 5,
  },
  header: {
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
  },
  description: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  buttons: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 8,
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "50%",
    height: 32,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
  imageBg: {
    marginTop: 16,
  },
  associatedText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
    textAlign: "center",
    marginTop: 13,
  },
});
